// extracted by mini-css-extract-plugin
export default {"baseButton":"Kckobg2","wrapper":"kux2srm","icon":"hZRjdHi","rotateIcon":"IrS3eVn","rotate":"AS4xYXJ","label":"WEjBDAH","input":"U2UombN"};